"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncStateStatus = void 0;
var AsyncStateStatus;
(function (AsyncStateStatus) {
    AsyncStateStatus["ERROR"] = "ERROR";
    AsyncStateStatus["INITIAL"] = "INITIAL";
    AsyncStateStatus["LOADING"] = "LOADING";
    AsyncStateStatus["SUCCESS"] = "SUCCESS";
})(AsyncStateStatus || (exports.AsyncStateStatus = AsyncStateStatus = {}));
//# sourceMappingURL=AsyncFnState.js.map